import { React, useState } from 'react';
import { Button } from 'devextreme-react/button';
import { CaseForms } from '../../../Constantes/caseForms';

export default function Form(props) {
  const { classes, submitForm, type, handleShowForms, disabledButtom, template, dataForm, setDataForm, disableSubmit, dataFormAttachments, setDataFormAttachments } = props;
  const [names, setNames] = useState(null);

  return (
    <form>
      <CaseForms
        setDataForm={setDataForm}
        setNames={setNames}
        dataForm={dataForm}
        classes={classes}
        template={template}
        dataFormAttachments={dataFormAttachments}
        setDataFormAttachments={setDataFormAttachments}
      ></CaseForms>
      <div
        className={classes.controlers}
        style={{
          paddingTop: 10,
          paddingBottom: 10,
          display: 'flex',
          justifyContent: 'space-between',
        }}
      >
        <Button className="send" disabled={disabledButtom} type="normal" onClick={() => handleShowForms(type)} stylingMode="contained" text="Cancelar" />
        {/* <Button
          className="send"
          disabled={disabledButtom || disableSubmit}
          type="normal"
          id={'draftButton'}
          onClick={() => submitForm(dataForm, names, true)}
          stylingMode="contained"
          text="Rascunho"
        /> */}
        <Button
          disabled={disabledButtom || disableSubmit}
          className="send"
          id={'submitButton'}
          type="normal"
          width={83}
          onClick={() => submitForm(dataForm, names, false)}
          stylingMode="contained"
          text="Aceitar"
        />
      </div>
    </form>
  );
}
